var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fef4282e3698a4a6c86875b76f06e60035a30a2b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yoco-com@yoco-technologies"]={id:"fef4282e3698a4a6c86875b76f06e60035a30a2b"};
      